import { gql } from '@apollo/client';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import CLASSROOM_LICENSE_USAGE from 'graph/fragments/classroom-license-usage';
import USER_ORGANIZATION_FRAGMENT from 'graph/fragments/user-organization';
import CLASSROOM_STATS_FRAGMENT from 'graph/fragments/classroom-stats';

const GET_USER_CLASSROOMS_AND_ORGANIZATIONS_WITH_ROLES = gql`
  query getClassroomsAndOrganizationsWithRoles($userId: Int!) {
    user(where: { id: $userId }) {
      organizationAssociations {
        ...BaseUserOrganization
      }
    }
    classrooms(
      where: { archived: false }
      whereUser: { id: [$userId] }
      orderBy: { field: NAME, direction: ASC }
    ) {
      ...BaseClassroom
      licenseUsage {
        ...BaseClassroomLicenseUsage
      }
      stats {
        ...BaseClassroomStats
      }
    }
  }
  ${CLASSROOM_FRAGMENT}
  ${USER_ORGANIZATION_FRAGMENT}
  ${CLASSROOM_LICENSE_USAGE}
  ${CLASSROOM_STATS_FRAGMENT}
`;

export default GET_USER_CLASSROOMS_AND_ORGANIZATIONS_WITH_ROLES;
